// @flow

import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { ProgressIndicator } from '@fortress-technology-solutions/fortress-component-library/Molecules';

export const getMessageKey = (value: number | undefined) => {
  if (value === 0 || value === undefined) {
    return 'app.notStarted';
  }
  if (value === 100) {
    return 'app.completed';
  }
  return 'app.inProgress';
};

const ListItemProgressBar = ({
  icon,
  primaryText,
  to,
  disabled = false,
  progressValue = 0,
  secondary,
}) => {
  return (
    <ListItemButton LinkComponent={Link} to={to} disabled={disabled}>
      <ListItemIcon>{icon}</ListItemIcon>
      <ListItemText
        primary={primaryText}
        primaryTypographyProps={{
          color: 'text.primary',
        }}
        secondary={
          secondary ?? (
            <ProgressIndicator
              label={<FormattedMessage id={getMessageKey(progressValue)} />}
              value={progressValue}
            />
          )
        }
        secondaryTypographyProps={{
          component: 'div',
        }}
      />
    </ListItemButton>
  );
};

export default ListItemProgressBar;
